import {UIController} from "../UIController";

/******************************************************************
 * ReadingTimeController
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class ReadingTimeController extends UIController {

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(rootElement: HTMLElement) {
        super(rootElement);
        const minutes =
            this.getReadingTime(".kkt-text") +
            this.getReadingTime(".kkt-accordion") +
            this.getReadingTime(".kkt-vitealist") +
            this.getReadingTime(".kkt-factlist") +
            this.getReadingTime(".kkt-reviews") +
            this.getReadingTime(".kkt-article-section-headline")
        this.getReadingTime(".kkt-article-header-content-abstract")
        rootElement.innerText = rootElement.innerText.replace("{MINUTES}", Math.ceil(minutes ?? 0).toString());
    }

    /******************************************************************
     * PRIVATE METHODES
     *****************************************************************/

    private getReadingTime(selector: string, wordsPerMinute: number = 250): number {
        const elements = document.querySelectorAll(selector);
        if (!elements) {
            return 0;
        }
        let text: string = "";
        Array.from(elements).forEach(element => {
            text += element.textContent?.trim() ?? ""
        })
        const wordCount = text.split(/\s+/).length;
        return wordCount / wordsPerMinute;
    }

}
